import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ItemStatusChips from '../ItemStatusChips';
import { typeInfo } from '../../../../../components/changelog/changelogConfig';

function EditionItemRow({ item, index, canMoveUp, canMoveDown, onMove, onToggleHighlight, onRemove }) {
  const type = typeInfo(item.type);
  return (
    <Box
      component="li"
      sx={{
        display: 'flex', alignItems: 'center', gap: 1, p: 1.25, borderRadius: '10px',
        border: '1px solid', borderColor: item.awaiting_deploy ? '#F5C2C0' : '#E2E8F0',
        backgroundColor: item.edition_highlight ? '#FFFBEB' : '#fff',
      }}
    >
      <Typography variant="caption" color="text.disabled" sx={{ width: 20, textAlign: 'right', flexShrink: 0 }}>{index + 1}</Typography>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="caption" sx={{ color: type.color, fontWeight: 700 }}>{type.label}</Typography>
          <ItemStatusChips item={item} />
        </Box>
        <Typography variant="body2" sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.title}>
          {item.title || 'Sem título'}
        </Typography>
      </Box>
      <Tooltip title={item.edition_highlight ? 'Tirar o destaque' : 'Destacar neste envio'}>
        <IconButton size="small" onClick={() => onToggleHighlight(item.id)}>
          {item.edition_highlight ? <StarRoundedIcon fontSize="small" sx={{ color: '#F59E0B' }} /> : <StarBorderRoundedIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
      <Tooltip title="Subir">
        <span><IconButton size="small" disabled={!canMoveUp} onClick={() => onMove(index, -1)}><ArrowUpwardRoundedIcon fontSize="small" /></IconButton></span>
      </Tooltip>
      <Tooltip title="Descer">
        <span><IconButton size="small" disabled={!canMoveDown} onClick={() => onMove(index, 1)}><ArrowDownwardRoundedIcon fontSize="small" /></IconButton></span>
      </Tooltip>
      <Tooltip title="Tirar do envio">
        <IconButton size="small" onClick={() => onRemove(item.id)}><CloseRoundedIcon fontSize="small" /></IconButton>
      </Tooltip>
    </Box>
  );
}

/**
 * Itens de um envio na ordem do e-mail, com destaque por envio, subir, descer e tirar.
 * @param {{ items: Array, onMove: Function, onToggleHighlight: Function, onRemove: Function }} props
 */
function EditionItemsList({ items, onMove, onToggleHighlight, onRemove }) {
  if (items.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center', border: '1px dashed #CBD5E1', borderRadius: '10px' }}>
        <Typography variant="body2" color="text.secondary">Nenhum item neste envio ainda.</Typography>
      </Box>
    );
  }
  return (
    <Box component="ol" sx={{ listStyle: 'none', p: 0, m: 0, display: 'grid', gap: 1 }}>
      {items.map((item, index) => (
        <EditionItemRow
          key={item.id}
          item={item}
          index={index}
          canMoveUp={index > 0 && items[index - 1].edition_highlight === item.edition_highlight}
          canMoveDown={index < items.length - 1 && items[index + 1].edition_highlight === item.edition_highlight}
          onMove={onMove}
          onToggleHighlight={onToggleHighlight}
          onRemove={onRemove}
        />
      ))}
    </Box>
  );
}

export default EditionItemsList;
